<div *ngIf="value" class="row d-flex justify-content-center">
  <div class=" col-xs-12" style="padding: 3rem;">
    <img [src]="value" [alt]="title" style="max-height: 30rem; max-width: 90rem" (click)="preview()">
  </div>
</div>
